import { DefaultService } from '@/services/DefaultService';

export default class CulturaService extends DefaultService {

    constructor(http, router, env) {
        super(http, router, env);
    }

    updateSituacao(tipocultura, contexto = "agro") {
        return this._http.post(`${this._env}/${contexto}/tipocultura/updatesituacao`, tipocultura, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw err;
        });
    }

    save(tipocultura, contexto = "agro") {
        return this._http.post(`${this._env}/${contexto}/tipocultura`, tipocultura, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw new Error('Problems while jobs are loading');
        });
    }

    saveChecks(tipocultura, contexto = "agro") {
        return this._http.post(`${this._env}/${contexto}/tipocultura/checks`, tipocultura, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw new Error('Problems while jobs are loading');
        });
    }

    find(id, contexto = "agro") {
        return this._http.get(`${this._env}/${contexto}/tipocultura/${id}.json`, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw new Error('Problems while jobs are loading');
        });
    }

    delete(id) {
        return this._http.delete(`${this._env}/agro/tipocultura/${id}`, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw new Error('Problems while jobs are loading');
        });
    }

    findAll(page = 0, limit = 50, situacao = 2, order = 'asc', column = 'descricao', contexto = "agro", ...params) {
        return this._http.get(encodeURI(`${this._env}/${contexto}/tipocultura.json?page=${page}&limit=${limit}&situacao=${situacao}&order=${order}&column=${column}&param=${params}`), this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw new Error('Problems while jobs are loading');
        });
    }

    findAllCombo(params) {
        return this.findAllComboSituacao(1, params)
    }
    findAllComboSituacao(situacao = 1, ...params) {
        return this._http.get(encodeURI(`${this._env}/agro/tipocultura/getcombo.json?situacao=${situacao}&param=${params}`), this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw new Error('Problems while jobs are loading');
        });
    }
}